import { c as _c } from "react/compiler-runtime";
import { FC } from "react";
import styles from "./index.module.scss";
type SeoContentType = {
  html: string;
};
export const SeoContent: FC<SeoContentType> = t0 => {
  const $ = _c(2);
  const {
    html
  } = t0;
  if (!html || html.trim() === "") {
    return null;
  }
  let t1;
  if ($[0] !== html) {
    t1 = <article className="relative flex flex-col" id={styles["seo-content"]} dangerouslySetInnerHTML={{
      __html: html
    }} />;
    $[0] = html;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};